module.exports = __webpack_public_path__ + "img/WS.fd6f5549.png";